import React from "react";

const MicroWidget = (props: any) => {
  const getMarginTop = () => {
    let margin = 12;

    if (typeof props.position !== "undefined" && props.position != null) {
      margin += Number(props.position) * 100;
    }
    return margin + "px";
  };

  const getIcon = () => {
    let icon = "";

    if (typeof props.icon !== "undefined" && props.icon != null) {
      return "" + props.icon;
    }
    return icon;
  };

  return (
    <>
      <div
        className="inb-widget-small"
        style={{ whiteSpace: "pre-line", marginTop: getMarginTop() }}
      >
        <div
          className={getIcon() + " " + "widget-icon"}
          style={{ transform: "translate(4px, 2px)", marginRight: "2px" }}
        ></div>
        <div className="inb-widget-label-wrapper">
          <label>{props.value}</label>
        </div>
        <span>{props.title}</span>
      </div>
    </>
  );
};

export default MicroWidget;
